export const tr = {
  // Genel
  common: {
    save: 'Kaydet',
    cancel: 'İptal',
    delete: 'Sil',
    edit: 'Düzenle',
    add: 'Ekle',
    search: 'Ara',
    filter: 'Filtre',
    export: 'Dışa Aktar',
    import: 'İçe Aktar',
    loading: 'Yükleniyor...',
    noData: 'Veri bulunamadı',
    confirm: 'Onayla',
    yes: 'Evet',
    no: 'Hayır',
    all: 'Tümü',
    total: 'Toplam',
    date: 'Tarih',
    today: 'Bugün',
    month: 'Ay',
    year: 'Yıl',
    week: 'Hafta',
    daily: 'Günlük',
    weekly: 'Haftalık',
    monthly: 'Aylık',
    yearly: 'Yıllık',
    from: 'Başlangıç',
    to: 'Bitiş',
    amount: 'Tutar',
    quantity: 'Miktar',
    unit: 'Birim',
    price: 'Fiyat',
    unitPrice: 'Birim Fiyat',
    totalAmount: 'Toplam Tutar',
    description: 'Açıklama',
    category: 'Kategori',
    status: 'Durum',
    actions: 'İşlemler',
    notes: 'Notlar',
    supplier: 'Tedarikçi',
    product: 'Ürün',
    name: 'Ad',
    type: 'Tip',
    dateRange: 'Tarih Aralığı',
    success: 'Başarılı',
    error: 'Hata',
    warning: 'Uyarı',
    info: 'Bilgi',
  },

  // Navigasyon / Menü
  nav: {
    home: 'Ana Sayfa',
    products: 'Ürünler',
    stockOperations: 'Stok İşlemleri',
    stockReport: 'Stok Raporu',
    prepKitchen: 'Hazırlık Mutfağı',
    transfer: 'Sevkiyat',
    transferInvoice: 'Sevk İrsaliyesi',
    transferCost: 'Sevkiyat Maliyeti',
    paymentReport: 'Ödeme Raporu',
    checkManagement: 'Çek Takibi',
    loanManagement: 'Kredi Takibi',
    expenses: 'Gider Menüsü',
    vegetables: 'Sebze/Manav',
    meat: 'Et/Tavuk',
    generalProducts: 'Genel Ürünler',
    profitLoss: 'Kar/Zarar',
    recipes: 'Reçeteler',
    staff: 'Personel',
    suppliers: 'Tedarikçiler',
    users: 'Kullanıcılar',
    settings: 'Ayarlar',
    logout: 'Çıkış Yap',
    inventoryCount: 'Sayım',
    orderSuggestion: 'Sipariş Önerisi',
    sales: 'Satış',
    staffMeals: 'Personel Yemeği',
    mealPlanning: 'Yemek Planı',
    smartMenu: 'Akıllı Menü',
    reports: 'Raporlar',
  },

  // Giriş Sayfası
  auth: {
    welcome: 'Hoş Geldiniz',
    loginSubtitle: 'Restoran stok yönetim sistemine giriş yapın',
    email: 'E-posta Adresi',
    password: 'Şifre',
    login: 'Giriş Yap',
    register: 'Kayıt Ol',
    noAccount: 'Hesabınız yok mu?',
    hasAccount: 'Zaten hesabınız var mı?',
    forgotPassword: 'Şifremi Unuttum',
    rememberMe: 'Beni Hatırla',
    loginError: 'Giriş başarısız',
    loginSuccess: 'Giriş başarılı',
    logoutSuccess: 'Çıkış yapıldı',
    serverWaking: 'Sunucu başlatılıyor, lütfen bekleyin...',
  },

  // Ana Sayfa / Dashboard
  dashboard: {
    title: 'Ana Sayfa',
    subtitle: 'Restoranınızın güncel durumunu görüntüleyin',
    totalStockValue: 'Toplam Stok Değeri',
    todayNetProfit: 'Bugünkü Net Kar',
    lowStock: 'Düşük Stok',
    monthNetProfit: 'Bu Ay Net Kar',
    criticalLevel: 'Ürün kritik seviyede',
    expense: 'Gider',
    profitLossChart: 'Kar/Zarar Grafiği',
    mostUsed: 'En Çok Kullanılan',
    noDataYet: 'Henüz veri yok',
    products: 'ürün',
    grossRevenue: 'Brüt',
    sales: 'satış',
    loss: 'Zarar',
    profit: 'Kar',
  },

  // Ürünler
  products: {
    title: 'Ürünler',
    subtitle: 'Ürün tanımları ve stok durumu',
    addProduct: 'Ürün Ekle',
    editProduct: 'Ürün Düzenle',
    productName: 'Ürün Adı',
    productCode: 'Ürün Kodu',
    warehouseStock: 'Depo Stok',
    storeStock: 'Mağaza Stok',
    minStock: 'Minimum Stok',
    maxStock: 'Maksimum Stok',
    criticalStock: 'Kritik Stok',
    lastPurchaseDate: 'Son Alım Tarihi',
    packageInfo: 'Koli/Paket Bilgisi',
    packageQuantity: 'Koli İçi Adet',
    packagePrice: 'Koli Fiyatı',
    firePercentage: 'Fire Oranı',
  },

  // Stok İşlemleri
  stockOperations: {
    title: 'Stok İşlemleri',
    subtitle: 'Stok giriş ve çıkış işlemleri',
    entry: 'Giriş',
    exit: 'Çıkış',
    transfer: 'Transfer',
    adjustment: 'Düzeltme',
    warehouse: 'Depo',
    store: 'Mağaza',
    fromWarehouse: 'Depodan',
    toStore: 'Mağazaya',
  },

  // Gider Menüsü
  expenses: {
    title: 'Gider Menüsü',
    subtitle: 'İşletme giderlerini yönetin',
    addExpense: 'Gider Ekle',
    editExpense: 'Gider Düzenle',
    monthlyTotal: 'Bu Ay Toplam',
    untilDate: 'güne kadar',
    fixedExpenses: 'Sabit Giderler',
    dailyExpenses: 'Günlük Giderler',
    expenseCount: 'Gider Sayısı',
    dailyTotal: 'Günlük Toplam',
    dailyExpense: 'Günlük Gider',
    fixedExpenseDaily: 'Sabit Gider (Günlük)',
    fixed: 'Sabit',
    daily: 'Günlük',
    applyTemplates: 'Şablonları Uygula',
    transferSalaries: 'Maaşları Aktar',
    gasInvoice: 'Tüp Faturası',
    paymentType: 'Ödeme Türü',
    cash: 'Nakit',
    creditCard: 'Kredi Kartı',
    bankTransfer: 'Havale/EFT',
    check: 'Çek',
    dailyEffect: 'Günlük Etki',
    perMonth: '/ay',
    // Kategoriler
    categories: {
      rent: 'Kira',
      electricity: 'Elektrik',
      water: 'Su',
      gas: 'Doğalgaz/Kömür',
      internet: 'İnternet',
      phone: 'Telefon',
      insurance: 'SGK/Sigorta',
      salary: 'Personel Maaşları',
      fuel: 'Benzin',
      maintenance: 'Bakım/Onarım',
      cleaning: 'Temizlik',
      marketing: 'Pazarlama',
      courier: 'Kurye/Motor',
      extraStaff: 'Extra Personel',
      flour: 'Un',
      cylinder: 'Tüp',
      other: 'Diğer',
    },
  },

  // Sebze/Manav
  vegetables: {
    title: 'Sebze/Manav Takibi',
    subtitle: 'Sebze ve meyve alımlarını yönetin',
    addEntry: 'Sebze/Manav Ekle',
    importPdf: 'PDF\'den Aktar',
    totalSpending: 'Toplam Harcama',
    records: 'kayıt',
    bySupplier: 'Tedarikçi Bazlı',
    byProduct: 'Ürün Bazlı',
  },

  // Et/Tavuk
  meat: {
    title: 'Et/Tavuk Takibi',
    subtitle: 'Et, tavuk ve balık alımları, karkas işleme',
    addEntry: 'Et/Tavuk Ekle',
    importPdf: 'PDF\'den Aktar',
    totalSpending: 'Toplam Harcama',
    entryList: 'Giriş Listesi',
    prepKitchen: 'Hazırlık Mutfağı',
    reports: 'Raporlar',
    carcass: 'Karkas',
    portioned: 'Parçalı',
    processed: 'İşlenmiş',
    categories: {
      chicken: 'Tavuk',
      beef: 'Dana',
      lamb: 'Kuzu',
      fish: 'Balık',
      offal: 'Sakatat',
    },
  },

  // Hazırlık Mutfağı
  prepKitchen: {
    title: 'Hazırlık Mutfağı',
    subtitle: 'Karkas et ve tavuk işleme, parçalama',
    newTemplate: 'Yeni Şablon',
    templates: 'Şablonlar',
    history: 'İşleme Geçmişi',
    totalProcessed: 'Toplam İşlenen',
    totalOutput: 'Toplam Çıktı',
    totalWaste: 'Toplam Fire',
    wasteCost: 'Fire Maliyeti',
    avgWaste: 'Ort.',
    queue: 'Hazırlık Mutfağı Kuyruğu',
    pending: 'Bekleyen',
    processedItems: 'İşlenmiş',
    process: 'İşle',
    rawMaterial: 'Hammadde',
    outputs: 'Çıktılar',
    waste: 'Fire',
  },

  // Sevkiyat
  transfer: {
    title: 'Sevkiyat',
    subtitle: 'Depodan mağazaya ürün transferi',
    newTransfer: 'Yeni Sevkiyat',
    transferDate: 'Sevk Tarihi',
    transferList: 'Sevkiyat Listesi',
    pendingTransfers: 'Bekleyen Sevkiyatlar',
    completedTransfers: 'Tamamlanan Sevkiyatlar',
    fromWarehouse: 'Depodan',
    toStore: 'Mağazaya',
    approve: 'Onayla',
    reject: 'Reddet',
  },

  // Sevkiyat Maliyeti
  transferCost: {
    title: 'Sevkiyat Maliyeti',
    subtitle: 'Depodan mağazaya giden ürünlerin maliyeti',
    totalCost: 'Toplam Maliyet',
    totalTransfers: 'Toplam Sevkiyat',
    avgCostPerTransfer: 'Ortalama Maliyet',
    dailySummary: 'Günlük Özet',
    byCategorySummary: 'Kategori Özeti',
  },

  // Kar/Zarar
  profitLoss: {
    title: 'Kar/Zarar Raporu',
    subtitle: 'Günlük ve aylık kar zarar analizi',
    expenseDistribution: 'Gider Dağılımı',
    costSummary: 'Maliyet Özeti',
    dailyDetail: 'Günlük Detay',
    weeklySummary: 'Haftalık Özet',
    revenueEntries: 'Ciro Girişleri',
    addDailyRevenue: 'Günlük Ciro Ekle',
    addMonthlyRevenue: 'Aylık Ciro Ekle',
    totalRevenue: 'Toplam Ciro',
    totalCost: 'Toplam Maliyet',
    netProfit: 'Net Kar',
    profitMargin: 'Kar Marjı',
    avgDailyRevenue: 'Günlük Ort. Ciro',
    avgDailyCost: 'Günlük Ort. Maliyet',
    avgDailyProfit: 'Günlük Ort. Kar',
    revenue: 'Ciro',
    cost: 'Maliyet',
    profit: 'Kar',
    loss: 'Zarar',
    // Maliyet kategorileri
    generalExpenses: 'Genel Giderler',
    vegetablesCost: 'Sebze/Manav',
    meatCost: 'Et/Tavuk',
    staffSalaries: 'Personel Maaşları',
    generalProductsCost: 'Genel Ürünler',
    transferCost: 'Sevkiyat Maliyeti',
    checksDue: 'Vadesi Gelen Çekler',
  },

  // Genel Ürünler
  generalProducts: {
    title: 'Genel Ürünler',
    subtitle: 'Temizlik, içecek, ambalaj ve diğer ürünler',
    addEntry: 'Ürün Girişi Ekle',
    importPdf: 'PDF\'den Aktar',
    categories: {
      cleaning: 'Temizlik',
      beverage: 'İçecek',
      packaging: 'Ambalaj',
      kitchen: 'Mutfak Ekipmanı',
      office: 'Ofis/Kırtasiye',
      other: 'Diğer',
    },
  },

  // Çek Takibi
  checks: {
    title: 'Çek Takibi',
    subtitle: 'Alınan ve verilen çekleri yönetin',
    addCheck: 'Çek Ekle',
    receivedChecks: 'Alınan Çekler',
    givenChecks: 'Verilen Çekler',
    checkNo: 'Çek No',
    bank: 'Banka',
    dueDate: 'Vade Tarihi',
    collected: 'Tahsil Edildi',
    paid: 'Ödendi',
    pending: 'Bekliyor',
    overdue: 'Vadesi Geçmiş',
  },

  // Kredi Takibi
  loans: {
    title: 'Kredi Takibi',
    subtitle: 'Yatırım kredileri ve ödemeleri',
    addLoan: 'Kredi Ekle',
    addPayment: 'Ödeme Ekle',
    loanAmount: 'Kredi Tutarı',
    remainingAmount: 'Kalan Tutar',
    paidAmount: 'Ödenen Tutar',
    interestRate: 'Faiz Oranı',
    startDate: 'Başlangıç Tarihi',
    endDate: 'Bitiş Tarihi',
    installment: 'Taksit',
    payments: 'Ödemeler',
    currency: 'Para Birimi',
    exchangeRate: 'Döviz Kuru',
  },

  // Personel
  staff: {
    title: 'Personel Yönetimi',
    subtitle: 'Çalışan bilgileri ve maaşları',
    addStaff: 'Personel Ekle',
    name: 'Ad Soyad',
    position: 'Pozisyon',
    salary: 'Maaş',
    startDate: 'İşe Başlama',
    phone: 'Telefon',
    active: 'Aktif',
    inactive: 'Pasif',
  },

  // Reçeteler
  recipes: {
    title: 'Reçeteler',
    subtitle: 'Ürün reçeteleri ve maliyetleri',
    addRecipe: 'Reçete Ekle',
    recipeName: 'Reçete Adı',
    ingredients: 'Malzemeler',
    portion: 'Porsiyon',
    cost: 'Maliyet',
    sellingPrice: 'Satış Fiyatı',
    profitMargin: 'Kar Marjı',
  },

  // Dil
  language: {
    title: 'Dil',
    turkish: 'Türkçe',
    english: 'English',
    selectLanguage: 'Dil Seçin',
  },

  // Aylar
  months: {
    january: 'Ocak',
    february: 'Şubat',
    march: 'Mart',
    april: 'Nisan',
    may: 'Mayıs',
    june: 'Haziran',
    july: 'Temmuz',
    august: 'Ağustos',
    september: 'Eylül',
    october: 'Ekim',
    november: 'Kasım',
    december: 'Aralık',
  },

  // Günler
  days: {
    monday: 'Pazartesi',
    tuesday: 'Salı',
    wednesday: 'Çarşamba',
    thursday: 'Perşembe',
    friday: 'Cuma',
    saturday: 'Cumartesi',
    sunday: 'Pazar',
  },

  // Hatalar ve Bildirimler
  messages: {
    saveSuccess: 'Kayıt başarılı',
    saveError: 'Kayıt sırasında hata oluştu',
    deleteSuccess: 'Silme başarılı',
    deleteError: 'Silme sırasında hata oluştu',
    deleteConfirm: 'Bu kaydı silmek istediğinizden emin misiniz?',
    loadError: 'Veriler yüklenirken hata oluştu',
    requiredField: 'Bu alan zorunludur',
    invalidEmail: 'Geçerli bir e-posta adresi girin',
    invalidNumber: 'Geçerli bir sayı girin',
    noChanges: 'Değişiklik yapılmadı',
    unsavedChanges: 'Kaydedilmemiş değişiklikler var',
  },
};
